

/**
 * 多语言配置，调用$translate.instant("key") 或者 translate filter在html上绑定 如： {{ 'key' | translate }}，即可获取
 */
let language = {
    BUILDER_COPYRIGTH_TITLE: "Copyright of your design",
    BUILDER_COPYRIGTH_DES1: "Please review your design as it will be printed without any additional editing by our team. We will not be liable for any of your content. Please confirm the following:",
    BUILDER_COPYRIGTH_DES2: " I confirm that all images, names, and other content added to my design are correct.",
    BUILDER_COPYRIGTH_DES3: " I own all copyrights for the content or have full authorization to use it.",
    BUILDER_COPYRIGTH_CANCEL_BTN:"NO",
    BUILDER_COPYRIGTH_CONFIRM_BTN:"Yes"
};

export { language }